// extracted by mini-css-extract-plugin
module.exports = {"workspaceBreadcrumb":"WorkspaceSubCatBreadcrumb--workspaceBreadcrumb--2U8Ym","icon":"WorkspaceSubCatBreadcrumb--icon--2edtg","title":"WorkspaceSubCatBreadcrumb--title--2Ew0-"};